import React from "react";
import './microsoft.css'

export type MicrosoftLoginButtonTheme =
  | "dark_short"
  | "light_short"
  | "dark"
  | "light";

interface MicrosoftLoginButtonProps {
  onClick?: any;
}

export const MicrosoftLoginButton: React.FunctionComponent<MicrosoftLoginButtonProps> = ({
  onClick,
}) => {
    return (
      <button style={{'border': '0.5px solid lightgrey', 'borderRadius': '5px'}} onClick={onClick.bind(this)} id="signInWithMicrosoft" className="msSignInButton bg-white hover:bg-slate-50">
      <span className="msIcon"></span>
      Sign in with Microsoft
    </button>
    );
};